import React, { useEffect, useState } from "react";
import MonterreyLandingVideo from "../components/monterrey/MonterreyLandingVideo";
import MonterreyLandingAbout from "../components/monterrey/MonterreyLandingAbout";
import MonterreyLandingCoaches from "../components/monterrey/MonterreyLandingCoaches";
import MonterreyLandingClassTypes from "../components/monterrey/MonterreyLandingClassTypes.js";
import MonterreyLandingSchedule from "../components/monterrey/MonterreyLandingSchedule.js";
import MonterreyLandingAccordion from "../components/monterrey/MonterreyLandingAccordion.js";
import MonterreyLandingPackages from "../components/monterrey/MonterreyLandingPackages.js";
import LandingImageBanner from "../components/monterrey/MonterreyLandingBanner.js";
import MonterreyLandingLocations from "../components/monterrey/MonterreyLandingLocations.js";
import { trialClassCheckoutRoute } from "../utils";
import "./LandingMonterrey.css";
import "../components/landing-online/LandingOnline.css";
import Footer from "../components/global/Footer.js";
import useBranch from "../hooks/useBranch";

const LandingMonterrey = () => {
  const { branch_id, presencialCityName } = useBranch();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      id="landing"
      className="vw-100 position-relative"
      style={{ overflow: 'hidden'}}
      data-bs-spy="scroll"
      data-bs-target="#monterrey-landing"
      data-bs-root-margin="0px 0px -40%"
      data-bs-smooth-scroll="true"
      tabIndex="0"
    >
      <MonterreyLandingVideo branch_id={branch_id} presencialCityName={presencialCityName} />
      <MonterreyLandingAbout branch_id={branch_id} />
      <MonterreyLandingClassTypes branch_id={branch_id} />
      <MonterreyLandingCoaches/>
      <MonterreyLandingSchedule />
      <MonterreyLandingAccordion/>
      <MonterreyLandingPackages branch_id={branch_id} />
      <LandingImageBanner
        src={`https://thebodymethod.s3.us-west-1.amazonaws.com/${
          branch_id === 2 ? "tj-banner.jpg" : "tbm-presencial-journey.jpg"
        }`}
        mobileSrc={`https://thebodymethod.s3.us-west-1.amazonaws.com/${
          branch_id === 2 ? "tj-banner.jpg" : "tbm-presencial-journey.jpg"
        }`}
        title="Start your TBM Journey"
        buttonText="COMIENZA YA"
        url={trialClassCheckoutRoute}
      />
      <MonterreyLandingLocations/>
      <Footer />
      <button
        type="button"
        className={`btn btn-primary landing-online__scroll-top-btn ${
          showScrollTop ? "landing-online__scroll-top-btn--visible" : ""
        }`}
        onClick={handleScrollToTop}
        aria-label="Volver arriba"
      >
        <i className="fa fa-chevron-up" />
      </button>
    </div>
  );
};

export default LandingMonterrey;
